import { Ref } from "vue";

export const useRotate = (
  targetElm: Ref<HTMLElement | undefined>,
  tempDeg: Ref<number>,
  rotateObject: (v: number) => void
) => {
  // 回転動作開始
  const pointerdown = (e: PointerEvent) => {
    const self = e.target as HTMLElement;
    // マウスをキャプチャ
    self.setPointerCapture(e.pointerId);
    self.onpointermove = pointermove;
  };
  // 回転動作終了
  const pointerup = (e: PointerEvent) => {
    const self = e.target as HTMLElement;
    self.releasePointerCapture(e.pointerId);
    self.onpointermove = null;

    //rotateが270以上だとマイナス80とかで持ってしまうので補正する(tempDeg)
    if (tempDeg.value < 0) {
      tempDeg.value = tempDeg.value + 360;
    }

    // 移動量を確定
    rotateObject(tempDeg.value);
  };
  // 回転
  const pointermove = (e: PointerEvent) => {
    const centerPos = getCenter();
    if (centerPos === undefined) return;
    const x = e.clientX - centerPos.x;
    const y = e.clientY - centerPos.y;
    const deg = calcDeg(x, y);
    // translateのrotateは0がTOPnanode+90する。
    tempDeg.value = deg + 90;
  };
  // 中心座標を取得する
  const getCenter = () => {
    const rect = targetElm.value?.getBoundingClientRect();
    if (rect === undefined) return;
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    return {
      x: centerX,
      y: centerY,
    };
  };
  // 角度を計算
  const calcDeg = (x: number, y: number): number => {
    const rad = Math.atan2(y, x);
    return (rad * 180) / Math.PI;
  };
  return {
    pointerdown,
    pointerup,
  };
};
